export const statisticCheckedInStyle = {
	wrapper: {
		width: '100%',
		height: '100%',
		overflow: 'inherit',
	},

	searchButton: {
		textTransform: 'inherit',
		width: '200px',

		'& svg': {
			width: '24px',
			height: '24px',

			'& path': {
				fill: 'var(--default-white)',
			},
		},
	},

	tableContent: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		height: 'calc(100% - 46px)',
	},

	container: {
		marginBottom: '40px',
	},

	table: {
		maxWidth: '1074px',
		tableLayout: 'fixed',
	},

	tableHeader: {
		'& > :nth-of-type(1)': {
			width: '9%',
			textTransform: 'capitalize',
		},
		'& > :nth-of-type(2)': {
			width: '23%',
		},
		'& > :nth-of-type(3)': {
			width: '22%',
		},
		'& > :nth-of-type(4)': {
			width: '12%',
			textTransform: 'capitalize',
		},
		'& > :nth-of-type(5)': {
			width: '22%',
		},
		'& > :nth-of-type(6)': {
			width: '12%',
		},
	},

	status: {
		'&.MuiTypography-root svg': {
			marginLeft: '4px',
		},
	},

	loader: {
		position: 'absolute',
		left: 'calc(50% - 25px)',
		top: '200px',
	},

	pagination: {
		display: 'flex',
		justifyContent: 'flex-end',
		marginRight: '16px',
		marginBottom: '48px',
	},

	tableRow: {
		height: '48px',
		padding: '12px 0 !important',
	},
};
